module.exports = __webpack_public_path__ + "img/134ne.62c78d56.svg";